/**
 * Util to execute a function on the next tick
 */
export function onNextTick(fn: Function): void {
  setTimeout(fn);
}
